import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@rtkwlf/pro-solid-svg-icons/faExclamationTriangle';
import { faRotateRight } from '@rtkwlf/pro-solid-svg-icons/faRotateRight';

import { useFenrirTranslation } from '../../../locales/use-fenrir-translation';
import { ErrorBase, type ErrorBaseProps } from '../error-base';
import {
  FontAwesomeGradientIcon,
  type FontAwesomeGradientIconProps,
} from '../font-awesome-gradient-icon';

export interface ErrorLoadingProps
  extends Pick<ErrorBaseProps, 'errorMessages' | 'actionLink'>,
    Pick<FontAwesomeGradientIconProps, 'iconMaskColor'> {
  body?: ErrorBaseProps['body'];
  reloadOnClick: () => void;
}

export const ErrorLoading = ({
  actionLink,
  body,
  iconMaskColor,
  errorMessages,
  reloadOnClick,
}: ErrorLoadingProps) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'errors' });

  const actionButton = {
    label: t('action.reload'),
    onClick: reloadOnClick,
    endIcon: <FontAwesomeIcon icon={faRotateRight} />,
  };

  const defaultBody = [t('errorLoading.body1'), t('errorLoading.body2')];

  return (
    <ErrorBase
      title={t('errorLoading.title')}
      body={body ?? defaultBody}
      icon={
        <FontAwesomeGradientIcon
          icon={faExclamationTriangle}
          iconMaskColor={iconMaskColor}
          size="4x"
        />
      }
      actionButton={actionButton}
      actionLink={actionLink}
      errorMessages={errorMessages}
    />
  );
};
